import LoggedInUser from './LoggedInUser';
import Helpers from './Helpers';

export function talents(limit, offset) {
  return fetch(Helpers.endpoint("/admin_talents"), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      auth_token: LoggedInUser.getInfo().auth_token
    })
  }).then((response) => response.json())

}
